import { IOfferSpendCrudModalLang, OFFER_SPEND_CRUD_MODAL_LANG_KEY } from './interface.IOfferSpendCrudModalLang'
import { IOfferSpendPageLang, OFFER_SPEND_PAGE_LANG_KEY } from './interface.IOfferSpendPageLang'
import { IOfferSpendListTableLang, OFFER_SPEND_LIST_TABLE_LANG_KEY } from './interface.IOfferSpendListTableLang'
import {
	IOfferSpendByAccountListTableLang,
	OFFER_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY
} from './interface.IOfferSpendByAccountListTableLang'
import {
	IOfferSpendByOfferListTableLang,
	OFFER_SPEND_BY_OFFER_LIST_TABLE_LANG_KEY
} from './interface.IOfferSpendByOfferListTableLang'
import {
	IOfferSpendByOfferDetailsTableLang,
	OFFER_SPEND_BY_OFFER_DETAILS_TABLE_LANG_KEY
} from './interface.IOfferSpendByOfferDetailsTableLang'
import {
	IOfferSpendByOfferScopeListTableLang,
	OFFER_SPEND_BY_OFFER_SCOPE_LIST_TABLE_LANG_KEY
} from './interface.IOfferSpendByOfferScopeListTableLang'
import {
	IOfferSpendByOfferScopeDetailsTableLang,
	OFFER_SPEND_BY_OFFER_SCOPE_DETAILS_TABLE_LANG_KEY
} from './interface.IOfferSpendByOfferScopeDetailsTableLang'

export * from './interface.IOfferSpendCrudModalLang'
export * from './interface.IOfferSpendPageLang'
export * from './interface.IOfferSpendListTableLang'
export * from './interface.IOfferSpendByAccountListTableLang'
export * from './interface.IOfferSpendByOfferListTableLang'
export * from './interface.IOfferSpendByOfferDetailsTableLang'
export * from './interface.IOfferSpendByOfferScopeListTableLang'
export * from './interface.IOfferSpendByOfferScopeDetailsTableLang'

export type IOfferSpendAllLang =
	& IOfferSpendPageLang
	& IOfferSpendCrudModalLang
	& IOfferSpendListTableLang
	& IOfferSpendByAccountListTableLang
	& IOfferSpendByOfferListTableLang
	& IOfferSpendByOfferDetailsTableLang
	& IOfferSpendByOfferScopeListTableLang
	& IOfferSpendByOfferScopeDetailsTableLang

export const OFFER_SPEND_ALL_LANG_KEY: IOfferSpendAllLang = {
	...OFFER_SPEND_CRUD_MODAL_LANG_KEY,
	...OFFER_SPEND_LIST_TABLE_LANG_KEY,
	...OFFER_SPEND_PAGE_LANG_KEY,
	...OFFER_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_LIST_TABLE_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_DETAILS_TABLE_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_SCOPE_LIST_TABLE_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_SCOPE_DETAILS_TABLE_LANG_KEY
}